import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import {
  filter as _filter,
  isEmpty as _isEmpty,
  sortBy as _sortBy,
  forEach as _forEach,
  each as _each,
  cloneDeep as _cloneDeep,
} from 'lodash';

import { getNameInCurrentLanguage } from 'helpers/intl';
import Loader from '../Loader';

import List from '../../List';

import IntlFormInlineSelector from '../../intlForm/IntlFormInlineSelector';
import CategorySelection from './CategorySelection';
import CategoryItems from './CategoryItems';

class ProductSelection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openedCategory: null,
      categoriesTree: [],
    };
  }

  getUrlData = () => {
    const urlData = { filters: {} };

    return urlData;
  };

  componentDidUpdate = prevProps => {
    const {
      appIntl: { displayIntlForm },
      list,
    } = this.props;
    const { categoriesTree } = this.state;

    // the categories list was loaded, prepare the tree in the state
    if (prevProps.list.pending && !list.pending && !list.hasError) {
      this.setState({ categoriesTree: this.unflatten(_cloneDeep(list.data.list)) });
    }

    // if the intl form display was changed, we need to recalculate the tree new (because of the title)
    if (prevProps.appIntl.displayIntlForm !== displayIntlForm) {
      this.setState({ categoriesTree: this.unflatten(this.flatten(_cloneDeep(categoriesTree))) });
    }
  };

  openCategory = categoryId => {
    this.setState({
      openedCategory: categoryId,
    });
  };

  closeCategory = () => {
    this.setState({
      openedCategory: null,
    });
  };

  unflatten = (array, parent, tree) => {
    const { appIntl } = this.props;

    tree = typeof tree !== 'undefined' ? tree : [];
    parent = typeof parent !== 'undefined' ? parent : { id: 0 };

    let children = _filter(array, child => {
      const lookForPath = parent.id + ',' + child.id + ',';
      return child.path.lastIndexOf(lookForPath) === child.path.length - lookForPath.length;
    });

    if (!_isEmpty(children)) {
      children = _sortBy(children, ['position']);
      _forEach(children, (child, index) => {
        child.position = index;
        child.title = (
          <span>
            <IntlFormInlineSelector />
            {getNameInCurrentLanguage(child.name, appIntl)}
          </span>
        );
      });
      if (parent.id === 0) {
        tree = children;
      } else {
        parent.children = children;
      }
      _each(children, child => {
        this.unflatten(array, child);
      });
    }

    return tree;
  };

  getOpenedCategory = (categoriesTree, categoryId) => {
    const { appIntl } = this.props;
    let foundCategory = null;
    let breadcrumb = [];
    _forEach(categoriesTree, (category, index) => {
      if (category.id === categoryId) {
        foundCategory = category;
        breadcrumb.push(
          <li key={category.id}>
            <a
              className="active"
              onClick={() => {
                this.openCategory(category.id);
              }}
            >
              {getNameInCurrentLanguage(category.name, appIntl)}
            </a>
          </li>
        );
      }
      if (typeof category.children !== 'undefined') {
        const lookInChildren = this.getOpenedCategory(category.children, categoryId);
        if (lookInChildren.category !== null) {
          foundCategory = lookInChildren.category;
          breadcrumb.push(
            <li key={category.id}>
              <a
                onClick={() => {
                  this.openCategory(category.id);
                }}
              >
                {getNameInCurrentLanguage(category.name, appIntl)}
              </a>
            </li>
          );
          breadcrumb = [...breadcrumb, ...lookInChildren.breadcrumb];
        }
      }
    });
    return {
      category: foundCategory,
      breadcrumb,
    };
  };

  render() {
    const { list, messages, appIntl, history, selectItem, selectedItem } = this.props;

    const { openedCategory, categoriesTree } = this.state;

    const categoryOpen = this.getOpenedCategory(categoriesTree, openedCategory);
    const breadcrumbs = [
      <li key={Date.now()}>
        <a
          onClick={() => {
            this.openCategory(null);
          }}
        >
          {messages.campaign.select_all}
        </a>
      </li>,
      ...categoryOpen.breadcrumb,
    ];

    return (
      <>
        {list.pending ? (
          <Loader />
        ) : (
          <div className="selection">
            <ul className="breadcrumb category-bread">{breadcrumbs}</ul>
            {categoryOpen.category === null && this.props.deviceTypes !== 'mobile' ? (
              categoriesTree.map((category, index) => {
                return (
                  <CategorySelection
                    key={index}
                    category={category}
                    index={index}
                    message={messages}
                    appIntl={appIntl}
                    history={history}
                    openCategory={this.openCategory}
                  />
                );
              })
            ) : /* mobile devices */
            categoryOpen.category === null && this.props.deviceTypes === 'mobile' ? (
              categoriesTree.map((category, index) => {
                if (category.on_mobile === true) {
                  return (
                    <CategorySelection
                      key={index}
                      category={category}
                      index={index}
                      message={messages}
                      appIntl={appIntl}
                      history={history}
                      openCategory={this.openCategory}
                    />
                  );
                }
              })
            ) : (
              /* end mobile devices */
              <>
                {this.props.deviceTypes !== 'mobile' &&
                  categoryOpen.category.children &&
                  categoryOpen.category.children.map((category, index) => {
                    return (
                      <CategorySelection
                        key={index}
                        category={category}
                        index={index}
                        message={messages}
                        appIntl={appIntl}
                        history={history}
                        openCategory={this.openCategory}
                      />
                    );
                  })}

                {this.props.deviceTypes === 'mobile' &&
                  categoryOpen.category.children &&
                  categoryOpen.category.children.map((category, index) => {
                    if (category.on_mobile === true) {
                      return (
                        <CategorySelection
                          key={index}
                          category={category}
                          index={index}
                          message={messages}
                          appIntl={appIntl}
                          history={history}
                          openCategory={this.openCategory}
                        />
                      );
                    }
                  })}

                <CategoryItems
                  category={categoryOpen.category}
                  message={messages}
                  history={history}
                  selectItem={selectItem}
                  openCategory={this.openCategory}
                  closeCategory={this.closeCategory}
                  selectedItem={selectedItem}
                />
              </>
            )}
          </div>
        )}
        <List
          listName="categories"
          url="/api/webshop/categories.json"
          list={list}
          urlData={this.getUrlData()}
          noRender
        />
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.categories, // edit
    user: state.login.user,
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ProductSelection)
  )
);
